import { Injectable } from "@angular/core";
import { HttpErrorHandlerService } from "./http-error-handler.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { BehaviorSubject, catchError, Observable, throwError } from "rxjs";

export interface Docket {
  docketId: number;
  docketName: string;
  currentFsName: string | null;
}

@Injectable({
  providedIn: "root",
})
export class HttpService {
  private apiUrl = "https://api.openai.com/v1/responses";
  private apiKey = "";

  private baseUrl: string;
  private sidebarState = new BehaviorSubject<boolean>(true);
  sidebarState$ = this.sidebarState.asObservable();

  private viewModeSource = new BehaviorSubject<"list" | "detail">("list");
  viewMode$ = this.viewModeSource.asObservable();

  constructor(
    private http: HttpClient,
    private errorHandler: HttpErrorHandlerService,
  ) {
    this.baseUrl = environment.apiUrl;
  }

   getLast30DaySummary(payload?:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/last-30-day-summary`, payload)  
  }

  getTodaySummary(payload?:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/today-summary`, payload)  
  }

   getGraphData(payload?:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/graph-data`, payload)  
  }

  getFsCardDetails(payload?:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/dashboard/fs-cards`, payload)  
  }


  formatDateDDMMYY(value: any) {
    if (!value) return "-";

  const date = new Date(value);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);

  return `${day}-${month}-${year}`;
}

  setViewMode(mode: "list" | "detail") {
    this.viewModeSource.next(mode);
  }

  toggleSidebar() {
    this.sidebarState.next(!this.sidebarState.value);
  }

  handleApiError(err: any): string {
    let message = "Something went wrong";
    if (err?.error) {
      if (typeof err.error === "string") {
        try {
          const parsed = JSON.parse(err.error);
          if (parsed?.error) {
            message = parsed.error;
          } else {
            message = err.error;
          }
        } catch {
          message = err.error;
        }
      } else if (err.error?.message) {
        message = err.error.message;
      }
    }
    return message;
  }

   getGoogleApiKey(): Observable<any> {
    return this.http.get<Docket[]>(`${this.baseUrl}/common/google-encryption-key`)
  }

  //@Chitti/Sanjay major bug will look in to it(staff)
  staffSendOtp(payload: any): Observable<any> {
   

    return this.http.post<any>(`${this.baseUrl}/staff/web/login`, payload);
    /*.pipe(
      catchError((error) => this.errorHandler.handleError(error))
    );*/
  }

  staffLogin(payload: any): Observable<any> {

    return this.http.post<any>(`${this.baseUrl}/auth/wlogin`, payload);
  }

  /*staffLogin(payload: any): Observable<any> {

    return this.http.post<any>(`${this.baseUrl}/staff/login`, payload);
  }*/

  /*resetPassword(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/reset-password`, payload);
  
  }*/

  resetPassword(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/forgotPassword`, payload);
  
  }

  changePassword(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/updateFirstTimePassword`, payload);
  
  }


  changeMyPassword(payload:any): Observable<any>{
    return this.http.post<any>(`${this.baseUrl}/auth/changeForgotPassword`, payload);
  }

  updatePassword(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/update-password`, payload);
  
  }

  //@Chitti/Sanjay major bug will look in to it(staff)
  staffVerifyOtp(mobileNumber: string, otp: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/staff/verify`, {
      mobileNumber,
      otp,
    });
  }

  /* bookings apis*/

  updateBooking(
    bookingId: number,
    payload: {
      canId: string;
      requestedCapacity: number;
      requestedDate: string;
    },
  ): Observable<any> {
    return this.http
      .put<any>(`${this.baseUrl}/${bookingId}`, payload)
      
  }

  cancelBooking(bookingId: number) {
    return this.http
      .post(`${this.baseUrl}/bookings/cancel/${bookingId}`, {})
    
  }

  getBookingHistory(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/bookings/booking/details/filters`, payload)
      
  }

  getPendingOrders(fsId: number): Observable<any> {
    return this.http
      .get<Docket[]>(`${this.baseUrl}/incharge/pendingOrdersCount/${fsId}`)
     
  }

  swapOrders(payload: any): Observable<any> {
    return this.http
      .post<any>(
        `${this.baseUrl}/incharge/swapMultipleBookingToAnotherFS`,
        payload,
      )
     
  }
  allocateTokens(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/allocate-tokens`, payload)
    
  }

  allocatePurposes(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/tokens/allocate/purposes`)
  }

tokenSearch(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/search-token`,
    payload
  );
}

  allocateFSTokens(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/allocate-fs-tokens`, payload)
      
  }

   allocateFSTokensAdmin(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/allocate-fs-tokens/admin`, payload)
      
  }

   getAdminFsUsageSummary(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/admin/fs/allocation/history`, payload)
      
  }

  getDivisionSummary(divisionId: string): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/tokens/division-summary/${divisionId}`)
   
  }

  getDivisionSummaryInArray(payload: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/tokens/division-summary`,payload);
  }

    getUsageReport(payload:any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/usage-report`,payload)
  }

  
  tokenDetails(payload: any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/tokens/token-details`, payload)
  }

   getBookingHistoryByCanId(payload: any,status:any): Observable<any> {
    return this.http
      .post<any>(`${this.baseUrl}/bookings/history/${status}`, payload)
      
  }

  /*filling station apis*/
  // ================== LISTING ==================
  searchStations(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/incharge/stations/search`, payload)
     
  }

  // ================== CIRCLES ==================
  getCircles(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/area/circle`)

  }
  // ================= DIVISIONS =================
  getDivisions(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/area/division`)
      
  }
  // ================== DIVISIONS BY CIRCLE ==================
  getDivisionsByCircle(circleId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/area/circle/${circleId}/divisions`)
     
  }

   getDivisionsByRegion(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/master/data/region/zone/divisions`,payload)
     
  }


  getDivisionsByCircleIds(circleIds: number[]): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/admin/area/circles/divisions`, { circleIds })
      
  }

  // ================== SECTIONS BY DIVISION ==================
  getSectionsByDivision(divisionId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/area/division/${divisionId}/sections`)
      
  }
  getAllFillingStations(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/manager/filling-stations`)
      
  }
  getAllActiveStationsByDivision(divisionId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/dm/division/${divisionId}/stations`)
     
  }

  getDivisionsByCircleId(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/admin/area/circles/divisions`, payload)
      
  }

  getStationsBySections(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/admin/area/sections/stations`, payload)
      
  }

  getSubdivionsByDivisionId(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/admin/area/divisions/subdivisions`, payload)
      
  }


  getSectionsBySubdivions(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/admin/area/subdivisions/sections`, payload)
     
  }

  // --------------all Filling Stations =============//

  getAllFIllingStations() {
    return this.http
      .get(`${this.baseUrl}/manager/filling-stations`)
      
  }

  getBookingsFilter() {
    return this.http
      .get(`${this.baseUrl}/bookings/booking/details/filters`)
      
  }

  // ================== CRUD STATIONS ==================
  createStation(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/incharge/stations`, payload)
     
  }

  updateStation(fsId: number, payload: any): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/incharge/stations/${fsId}`, payload)
     
  }

  deleteStation(fsId: number): Observable<any> {
    return this.http
      .delete(`${this.baseUrl}/incharge/stations/${fsId}`)
     
  }

  getStationById(fsId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/incharge/Fsdetails/${fsId}`)
 
  }

  // Get filling points for a station
  getFillingPoints(fsId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/incharge/filling-points/${fsId}`)
     
  } // Save or update a filling point

  getStations(divisionId: any): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/dm/division/${divisionId}/stations`)
    
  }

  getStationsNew(divisionId: any): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/area/division/${divisionId}/fs`)
  
  }

  getStationsByMasters(payload:any): Observable<any> {
    return this.http.post(`${this.baseUrl}/master/data/filling-stations/search`,payload)
  }
  // In service.ts
  deleteFillingPoint(fpId: number): Observable<any> {
    // ✅ Add return type
    return this.http
      .delete(`${this.baseUrl}/incharge/stations/points/${fpId}`)
 
  }

  // ================== FILLING POINTS ==================
  getRecentUpdates(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/admin/dm/recent-updates`)
      
  }

  getDocketsList(payload: any): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/admin/dm/list`,
    payload
  );
}

createDocket(payload: any): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/admin/dm/create`,
    payload
  );
}

updateDockets(docketId: any, payload: any): Observable<any> {
  return this.http.put(
    `${this.baseUrl}/admin/dm/update/${docketId}`,
    payload
  );
}

  updateDocketMapping(payload: {
    targetFsId: number;
    docketIds: number[];
  }): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/admin/dm/update-mapping`, payload)
  }

  getMappedDockets(payload:any):Observable<any>{
     return this.http
      .post(`${this.baseUrl}/admin/dm/mapped/dockets/filters`, payload)
  }

  getSectionDockets(sectionId: number): Observable<Docket[]> {
    return this.http
      .get<Docket[]>(`${this.baseUrl}/admin/dm/section/${sectionId}/dockets`)
     
  }

  getUnMappedDockets(payload:any){
    return this.http.post(`${this.baseUrl}/admin/dm/unmapped/dockets/search`, payload)
  }

  getDivisionStations(divisionId: number) {
    return this.http
      .get<any[]>(`${this.baseUrl}/admin/dm/division/${divisionId}/stations`)
  }

  saveFillingPoint(fsId: number, payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/incharge/stations/${fsId}/points`, payload)
  }

  /*logins apis*/

  sendOtp(loginId: string) {
    return this.http
      .post(
        `${this.baseUrl}/customers/login`,
        { loginId },
        { responseType: "text" },
      )
  }

 // sendOtpConsumer(payload: any) {
  //   return this.http.post(`${this.baseUrl}/consumer/login`, payload)
  // }

   sendOtpConsumer(payload: any) {
    return this.http.post(`${this.baseUrl}/auth/clogin`, payload)
  }


  verifyOtp(loginId: string, otp: string) {
    return this.http
      .post(
        `${this.baseUrl}/auth/cverify`,
        { loginId, otp },
        
      )
  }

  getCustomerDetails(loginId: string) {
    return this.http
      .get<any>(`${this.baseUrl}/customers/${loginId}`)
 
  }

  getTankerDetails() {
    return this.http
      .get(`${this.baseUrl}/bookings/tanker/details`)
 
  }

  loadTanker(tankerId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/tanker/${tankerId}`)

  }

  saveTanker(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/tanker/register-ui`, payload)

  }
  saveTankerMaster(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/tanker/create`, payload)

  }

   searchVehicleNumber(vehicleNumber: any): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/tanker/searchByVehicleNumber/${vehicleNumber}`)

  }

  searchTankers(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/tanker/search`, payload)
  }

  updateTanker(tankerId: any, payload: any): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/tanker/update-ui/${tankerId}`, payload)
  }

  // swapTanker(payload: any): Observable<any> {
  //   return this.http
  //     .post(`${this.baseUrl}/tanker/swapTankerToAnotherFS`, payload)
  // }

   swapTanker(payload: any): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/tanker/change/fs`, payload,{
        responseType: "text",
      })
  }

  deleteTanker(tankerId: any): Observable<any> {
    return this.http
      .delete(`${this.baseUrl}/tanker/${tankerId}`)
      
  }

  initiateBooking(payload: any) {
    return this.http
      .post(`${this.baseUrl}/bookings/book`, payload)
  }
  
  initiateBookingERP(payload: any) {
    return this.http
      .post(`${this.baseUrl}/customers/hmwssb/bookTanker`, payload,{ timeout: 600000  })
  }

  confirmBooking(bookingId: number) {
    return this.http
      .post(`${this.baseUrl}/bookings/confirm/${bookingId}`, {})
     
  }

  getOrderSummary(bookingId: number) {
    return this.http
      .get(`${this.baseUrl}/bookings/summary/${bookingId}`)
    
  }

  getPin(bookingId: number, payload: any) {
    return this.http
      .post(`${this.baseUrl}/manager/bookings/${bookingId}/get-pin`, payload)
      
  }

  signup(payload: any) {
    return this.http
      .post(`${this.baseUrl}/customers/signup`, payload)
      
  }

  verifySignupOtp(payload: { phoneNumber: string; otp: string }) {
    return this.http
      .post(`${this.baseUrl}/customers/verify-signup`, payload, {
        responseType: "text",
      })
      
  }

  /*Free trip Apis*/
  addFreeTrip(payload: any) {
    return this.http
      .post(`${this.baseUrl}/free-orders/create`, payload)
      
  }

  schedulePeriods(): Observable<any> {
    return this.http.get(`${this.baseUrl}/free-orders/schedulPeriods`);
  }

  getTankerTypes(fsId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/tanker/types/${fsId}`)
     
  }

  getTankerCapacities(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/tanker/tankerCapacities`)
      
  }

  getFreeTripById(id: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/free-orders/getById/${id}`)
     
  }

  getAllFreeTrips(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/free-orders/list`, payload)

  }

   getPurposes(type: any): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/free-orders/${type}`)
     
  }



  updateFreeTripStatus(payload: any): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/free-orders/updateStatus`, payload, {
        responseType: "text",
      })
     
  }

  updateFreeTrip(payload: any): Observable<any> {
    return this.http
      .put(`${this.baseUrl}/free-orders/update`, payload)
     
  }

  getlatlong(bookingId: any) {
    return this.http
      .get(`${this.baseUrl}/driver/tracking/last-location/${bookingId}`)
      
  }
  getDashboardStats(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/bookings/dashboard/sla-stats`, payload)
      
  }
  getDeliveryDeviation(payload: any) {
    return this.http.post(
      `${this.baseUrl}/incharge/reports/delivery-deviation`,
      payload,
    );
  }

  getFSDocketMapping(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/reports/getDocketFSMapping`)
      
  }

  //  getKLReport(): Observable<any> {
  //   return this.http.get(`${this.baseUrl}/reports/getKLReport`).pipe(
  //     catchError((error) => this.errorHandler.handleError(error))
  //   );
  // }

  getKLReport(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/getKLReport`, payload);
  }

  getTankerWiseTrips(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/tanker-wise-trips`, payload);
  }

  getManagerCardTripSummary(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/manager-card-trip-summary`, payload);
  }

  getMcc24HrsSummary(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/getMcc24HrsSummaryReport`, payload);
  }

  getTankerwiseAverageTrips(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/tanker-wise-average-trips`, payload);
  }


  getFSSettlementReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/getFSSettlementReport`,
      payload,
    );
  }

  getFSWiseDeliveryStatusReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/getFSWiseDeliveryStatusReport`,
      payload,
    );
  }

  getGatePassReport(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/gatepassreport`, payload);
  }

  // getFSSettlementReport(): Observable<any> {
  //   return this.http.get(`${this.baseUrl}/reports/getFSSettlementReport`).pipe(
  //     catchError((error) => this.errorHandler.handleError(error))
  //   );
  // }

  // getFSWiseDeliveryStatusReport(fsId: number): Observable<any> {
  //   return this.http
  //    .get(`${this.baseUrl}/reports/getFSWiseDeliveryStatusReport/${fsId}`)
  //    .pipe(
  //     catchError((error) => this.errorHandler.handleError(error))
  //   );
  // }

  //  getCANDiscrepancyReport() :Observable<any> {
  //   return this.http.get(`${this.baseUrl}/reports/getCANDiscrepancyReport`).pipe(
  //     catchError((error) => this.errorHandler.handleError(error))
  //   );
  // }

  getTankerAverageReports(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/tankerwiseaveragetrips`,
      payload,
    );
  }

  getDayWiseBookingAbstractReports(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/daywise-booking-abstract`, payload);
  }

  getWalletDebitReports(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/wallet-debit-report`, payload);
  }

  getMccStatusReports(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/mccstatus`, payload);
  }
  getgatepassdownloadReports(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/gatepassdownload`, payload);
  }

  getfsLocationTankerReports(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/tankerwise-lastgatepass-report`, payload);
  }



  getunrenewedfreetankers(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/unrenewed-free-tankers`,
      payload,
    );
  }
  getFsWiseDocket(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fs-wise-docket-report`,
      payload,
    );
  }

  getFsWisePendency(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fs-wise-pendency-report`,
      payload,
    );
  }

  getMCCPendencyReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mcc-pendency-report`,
      payload,
    );
  }

  getMonthlyAbstract(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/getMonthlyAbstractReport`,
      payload,
    );
  }
  daywisebookingdeliveredabstract(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/daywisebookingdeliveredabstract`,
      payload,
    );
  }

  FsReport(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/fs-report`, payload);
  }
  NonMccDomestic(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/non-mcc-domestic-report`,
      payload,
    );
  }

  cancelledMccTokens(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mcc-cancelled-tokens-report`,
      payload,
    );
  }
  fsSettlementSummary(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fs-settlement-summary`,
      payload,
    );
  }

   locBoardTrips(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/tanker-schedule-summary`,
      payload,
    );
  }

    mccExceedsSummary(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mcc-exceeds-summary`,
      payload,
    );
  }

  mccTripPending(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mcc-trips-pending-summary`,
      payload,
    );
  }

  nonmccTripPending(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/non-mcc-trip-details`,
      payload,
    );
  }


   FsBaseGate(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fsBaseGatePassReport`,
      payload,
    );
  }

   getCreditedTransactions(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/creditedTransactions`,
      payload,
    );
  }

  getDebitedTransactions(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/debitedTransactions`,
      payload,
    );
  }

  getfswiseTankerReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fs-wise-tanker-report`,
      payload,
    );
  }

  getBookingDeliveryReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/booking-delivery-report`,
      payload,
    );
  }

  getMCCTankerReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/tanker-report`,
      payload,
    );
  }




   getTankerTripDetails(payload): Observable<any> {
     return this.http.post(`${this.baseUrl}/reports/tankertripdetails`, payload);
   }

  getMccSameday(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mcc-sameday-report`,
      payload,
    );
  }
  getTankerTripWiseSummary(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/tankertripsummary`, payload);
  }

  getTankerAttendance(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/tankerattendancereport`,
      payload,
    );
  }

   getTankerAttendanceMonthly(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/tankermonthlyattendance`,
      payload,
    );
  }

   getPendingBeyondSLA(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/mccpendingbeyondsla`,
      payload,
    );
  }

   getFsTankerAttendanceSummary(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/fstankerattendancesummary`,
      payload,
    );
  } 
  getNewTanker(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/getNewTankersReport`,
      payload,
    );
  }

  getCANDiscrepancyReport(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/reports/getCANDiscrepancyReport`,
      payload,
    );
  }

  getDailyReport(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/dailyreport`, payload);
  }

  getTankerSummaryReport(payload): Observable<any> {
    return this.http.post(`${this.baseUrl}/reports/tanker-summary`, payload);
  }
  getDocketsByFsId(fsId: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/reports/getDocketFSMapping/${fsId}`)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

  getDocketHistory(payload: any){
    return this.http.post(`${this.baseUrl}/admin/dm/docketmapping/history`,payload);
  }

  getTankerExpiryReport(payload: any) {
    return this.http.post(
      `${this.baseUrl}/reports/getTankerExpiryReport`,
      payload,
    );
  }

  askQuestion(question: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.apiKey}`,
    });

    const body = {
      model: "gpt-4.1-nano",
      input: question,
    };

    return this.http.post<any>(this.apiUrl, body, { headers });
  }

  getFSBookings(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/bookings/fs/status`, payload)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

  swapToken(payload: any): Observable<any> {
    return this.http
      .post(
        `${this.baseUrl}/incharge/swapSelectedMultipleBookingToAnotherFS`,
        payload,
      )
      //.pipe( catchError((error) => {return throwError(() => error);}),);
  }

  // Driver Apis

  addDriver(payload: any) {
    return this.http.post(`${this.baseUrl}/driver/create`, payload).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  getDriverList(
    name?: string,
    mobileNumber?: any,
    page?: any,
    size?: any,
  ): Observable<any> {
    let params = new HttpParams();

    if (name) {
      params = params.set("name", name);
    }

    if (mobileNumber) {
      params = params.set("mobileNumber", mobileNumber);
    }

    if (page) {
      params = params.set("page", page);
    }

    if (size) {
      params = params.set("size", size);
    }

    return this.http.get<any>(`${this.baseUrl}/driver/list`, { params }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  getDriverById(id: number): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/driver/${id}`)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

 updateDriver(driverId: number, formData: FormData): Observable<any> {
  return this.http.put(`${this.baseUrl}/driver/${driverId}`, formData).pipe(
    catchError((error) => {
      return throwError(() => error);
    }),
  );
}

  updateTankerStatus(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/tanker/updateTankerStatus`, payload)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

  // Get Roles

  getAllRoles(): Observable<any> {
    return this.http
      .get(`${this.baseUrl}/common/roles`)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

   saveUser(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/addUser`, payload)
      //.pipe(catchError((error) => this.errorHandler.handleError(error)));
  }

  /*logout(payload: any): Observable<any> {
    return this.http
      .post(`${this.baseUrl}/staff/logout`, payload)
  }*/

  logout(): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/wlogout`,{})
  }

  consumerlogout(payload: any): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/customers/logout`,
    payload,
    { responseType: 'text' } 
  );
}

    registerUserByRole(role: string, payload: any) {

  const apiMap: any = {
    ADMIN: '/auth/register-admin',
    DOP: '/auth/register-director',
    DIRECTOR: '/auth/register-director',
    CGM: '/auth/register-cgm',
    GM: '/auth/register-gm',
    DGM: '/auth/register-dgm',
    MANAGER: '/auth/register-manager',
    IN_CHARGE: '/auth/register-incharge',
    ED:'/auth/register-ed',
    JMD:'/auth/register-jmd',
    MD:'/auth/register-md',

  };

  return this.http.post(
    `${this.baseUrl}${apiMap[role]}`,
    payload
  ).pipe(
    catchError((error) => {
      return throwError(() => error);
    })
  );
}

// updateUserByRole(role: string, id: number, payload: any) {

//   const apiMap: any = {
//     ADMIN: '/sa/update-admin/',
//     DOP: '/sa/update-director/',
//     DIRECTOR: '/sa/update-director/',
//     CGM: '/sa/update-cgm/',
//     GM: '/sa/update-gm/',
//     DGM: '/sa/update-dgm/',
//     MANAGER: '/sa/update-manager/',
//     IN_CHARGE: '/sa/update-incharge/',
//     ED: '/sa/update-ed/',
//     MD: '/sa/update-md/',
//     JMD: '/sa/update-jmd/',
//   };

//   return this.http.put(
//     `${this.baseUrl}${apiMap[role]}${id}`,
//     payload
//   ).pipe(
//     catchError((error) => {
//       return throwError(() => error);
//     })
//   );

// }

// getUserByRole(role: string, id: number) {

//   const apiMap: any = {
//     ADMIN: '/sa/admin/',
//     DOP: '/sa/director/',
//     DIRECTOR:'/sa/director/',
//     CGM: '/sa/cgm/',
//     GM: '/sa/gm/',
//     DGM: '/sa/dgm/',
//     MANAGER: '/sa/manager/',
//     IN_CHARGE: '/sa/incharge/',
//     ED:'/sa/ed/',
//     JMD:'/sa/jmd/',
//     MD:'/sa/md/'
//   };

//   return this.http.get(
//     `${this.baseUrl}${apiMap[role]}${id}`
//   );
// }

updateUserByRole(payload: any) {
  return this.http.put(
    `${this.baseUrl}/sa/staff/update`,
    payload
  ).pipe(
    catchError((error) => {
      return throwError(() => error);
    })
  );
}


getUserByRole(staffId: number, roleId: number) {
  return this.http.post(
    `${this.baseUrl}/sa/staff/details`,
    {
      staffId: staffId,
      roleId: roleId
    }
  );
}


deleteUserByRole(role:string,id:number){

 const apiMap:any = {
   ADMIN:'/sa/admin/',
   DOP:'/sa/director/',
   DIRECTOR:'/sa/director/',
   CGM:'/sa/cgm/',
   GM:'/sa/gm/',
   DGM:'/sa/dgm/',
   MANAGER:'/sa/manager/',
   IN_CHARGE:'/sa/incharge/',
   ED:'/sa/ed/toggle/',
   JMD:'/sa/jmd/toggle/',
   MD:'/sa/md/toggle/'
 };

 return this.http.delete(
   `${this.baseUrl}${apiMap[role]}${id}`
 );
}

  getStaffList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/sa/staff-list`,
      payload,
    );
  }


 /*updateSttaus(id: any) {
  return this.http.patch(
    `${this.baseUrl}/sa/toggle-status/${id}`,
    {}
  );
}*/

checkStaffMobileNumber(payload:any){
   return this.http.post(`${this.baseUrl}/common/checkStaffByMobile`,payload );
}

updateSttaus(payload: any) {
  return this.http.post(`${this.baseUrl}/sa/toggle-status`,payload);
}

/**********Master apis**************/

/* Region Apis*/
 createRegions(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/region/create`,payload,{ responseType: 'text' } );
  }

  updateRegion( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/region/update`, payload,{ responseType: 'text' } )
  }

   getRegionsById(regionId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/region/details/${regionId}`)  
  }

 updateRegionStatus(payload: any): Observable<string> {
  return this.http.put(
    `${this.baseUrl}/master/data/region/update/status`,
    payload,
    { responseType: 'text' }
  );
}

  getRegionsList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/region/list`,payload);
  }

  /* Zone Apis*/

  createZones(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/zone/create`,payload );
  }

  mapZonesToRegion( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/zone/mapping`, payload, )
  }

  updateZone(payload: any): Observable<any> {
    return this.http.put(
    `${this.baseUrl}/master/data/zone/update`,
    payload,
    
  );
}


   getZonesById(regionId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/zone/${regionId}`)  
  }

   updateZoneStatus( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/zone/toggle-status`, payload )
  }

   getZonesList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/zone/list`,payload);
  }


  

  /*Division Apis*/
  createDivisions(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/division/create`,payload);
  }

  mapDivisionToZone( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/division-zones/mapping`, payload, )
  }

   getDivisionByZoneId(zoneId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/division/all/${zoneId}`)  
  }

   getDivisionByDivisionId(divisionId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/division/${divisionId}`)  
  }

   updateDivision( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/division/update`, payload )
  }

  updateDivisionStatus( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/division/toggle-status`, payload )
  }

  getDivisionList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/division/list`,payload);
  }


  /*Circle Apis*/
   createCircle(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/circle/create`,payload);
  }

   mapCircleToDivision( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/circle-divisions/mapping`, payload, )
  }


  getCircleByDivisionId(divisionId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/circle/all/${divisionId}`)  
  }

  getCircleByCircleId(circleId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/circle/${circleId}`)  
  }

  updateCircle( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/circle/update`, payload )
  }

  updateCircleStatus( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/circle/toggle-status`, payload )
  }


   getCircleList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/circle/list`,payload);
  }


  /*****Ward Apis******/

  createWard(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/ward/create`,payload);
  }

   mapWardToCircle( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/ward-circles/mapping`, payload, )
  }

    getWardByCircleId(circleId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/ward/all/${circleId}`)  
  }


   getWardByWardId(wardId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/ward/${wardId}`)  
  }

   updateWard( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/ward/update`, payload )
  }

  
  updateWardStatus( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/master/data/ward/toggle-status`, payload )
  }

  getWardList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/master/data/ward/list`,payload);
  }

  /*****Fs stations by ward **** */

  createInchargeStation(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/incharge/stations`,payload);
  }

   getStationsByWardId(wardId: any): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/incharge/stations/ward/${wardId}`)  
  }

   updateInchargeStation( stationId: any,payload:any): Observable<any> {
    return this.http.put(`${this.baseUrl}/incharge/stations/${stationId}`, payload )
  }

    mappingFillingStations( stationId: any,payload:any): Observable<any> {
    return this.http.put(`${this.baseUrl}/incharge/filling-stations/mapping`, payload )
  }

  getInchargeFSList(payload): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/incharge/stations/list`,payload);
  }

    
  updateStationsStatus( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/incharge/filling-station/toggle-status`, payload )
  }

  trackTankerLocation(payload: any) {
  return this.http.post(
    `${this.baseUrl}/orders/trackTankerLocation`,
    payload
  );
}

orderDownload(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/booking/details/filters/download`,
    payload,
    {
      responseType: 'blob'  
    }
  );
}

downloadImages(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/download/images`,
    payload,);
}


// ZONES
getZonesByRegion(regionIds: any) {
  return this.http.post(`${this.baseUrl}/master/data/zones/regionIds`, {
    regionIds
  });
}

// DIVISIONS
getDivisionsByZone(zoneIds: any) {
  return this.http.post(`${this.baseUrl}/master/data/divisions/zoneIds`, {
    zoneIds
  });
}

// CIRCLES
getCirclesByDivision(divisionIds:any) {
  return this.http.post(`${this.baseUrl}/master/data/circles/divisionIds`, {
    divisionIds
  });
}

// WARDS
getWardsByCircle(circleIds:any) {
  return this.http.post(`${this.baseUrl}/master/data/ward/circleIds`, {
    circleIds
  });
}

// FILLING STATIONS
getStationsByWard(wardIds:any) {
  return this.http.post(`${this.baseUrl}/master/data/fs/wardIds`, {
    wardIds
  });
}

getCustomers(payload:any) {
  return this.http.post(`${this.baseUrl}/customers/search`, 
    payload
  );
}

 getOvertimeConfig() {
    return this.http
      .get(`${this.baseUrl}/common/config/overtime`)
 
  }

    updateOvertimeConfig( payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/common/config/overtime/update`, payload )
  }


  updateFsOvertimeSettings(payload:any) {
  return this.http.put(`${this.baseUrl}/manager/fs/over-time/update`, 
    payload,
    { responseType: 'text' }
  );
}

  getAllCreatedRoles() {
    return this.http
      .get(`${this.baseUrl}/common/role/details`)
  }

  updateRole(payload: any) {
    return this.http.put(`${this.baseUrl}/common/update/role`,
      payload,
      { responseType: 'text' }
    );
  }

    addRole(payload: any) {
    return this.http.post(`${this.baseUrl}/common/add/role`,
      payload,
      { responseType: 'text' }
    );
  }

   updateRoleStatus(payload: any) {
    return this.http.put(`${this.baseUrl}/common/role/status/update`,
      payload,
      { responseType: 'text' }
    );
  }

    updateFsStatus(payload: any) {
    return this.http.put(`${this.baseUrl}/incharge/filling-station/toggle-status`,
      payload,
    );
  }

  getRegionByUserId(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/region/user`)
  }

  getZonebyUserId(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/region/zone/user`,
      payload,
    );
  }

    getDivisionbyUserId(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/zone/division/user`,
      payload,
    );
  }

    getCirclebyUserId(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/division/circle/user`,
      payload,
    );
  }

    getWardbyUserId(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/circle/ward/user`,
      payload,
    );
    
  }

    getFsbyUserId(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/ward/fillingstation/user`,
      payload,
    );
  }

  getAllFsbyUserId(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/master/data/fillingstation/user`)
  }

  ////////////TripType Apis//////////////
   createTripType(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/triptype/create`,
      payload,{responseType: 'text'}
    );
  }

   getAllTripTypes(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/triptype/list`,
      payload,
    );
  }

  updateTripType(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/triptype/update`,
      payload,{responseType: 'text'}
    );
  }

  updateTripTypeStatus(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/triptype/status`,
      payload,{responseType: 'text'}
    );
  }
 ////////////Tanker Type////////////////
  createTankerType(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/tankertype/create`,
      payload,{responseType: 'text'}
    );
  }

   getAllTankerTypes(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/tankertype/list`,
      payload,
    );
  }

  updateTankerType(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/tankertype/update`,
      payload,{responseType: 'text'}
    );
  }

  updateTankerTypeStatus(payload: any) {
    return this.http.post(`${this.baseUrl}/master/data/tankertype/status`,
      payload,{responseType: 'text'}
    );
  }

    // Tanker Capacity Apis 

  createTankerCapacity(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/tankerCapacity/create`,
    payload
  );
}

updateTankerCapacity(id: number, payload: any) {
  return this.http.put(
    `${this.baseUrl}/master/data/tankerCapacity/update/${id}`,
    payload
  );
}

getTankerCapacityList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/tankerCapacity/list`,
    payload
  );
}

toggleTankerCapacity(id: number) {
  return this.http.patch(
    `${this.baseUrl}/master/data/tankerCapacity/toggle-status/${id}`,
    {}
  );
}

// Catogery 

createCategory(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/create`,
    payload
  );
}

updateCategory(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/category/update`,
    payload
  );
}

toggleCategory(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/category/toggle`,
    payload
  );
}

getCategoryList(payload: any) {

  return this.http.post(
    `${this.baseUrl}/master/data/category/search`,
    {
      tariff: payload.tariff || '',
      min: payload.min ?? '',
      max: payload.max ?? '',
      days: payload.days ?? '',
      trips: payload.trips ?? '',
      maxTrips: payload.maxTrips ?? '',
      page: payload.page,
      size: payload.size,
      sortBy: payload.sortBy,
      direction: payload.direction
    }
  );
}

// Add Trip Charge
addTripCharge(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/add-trip-charge`,
    payload
  );
}

// Trip Charge List
getTripChargeList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/trip-charge/list`,
    payload
  );
}

// Update Trip Charge
updateTripCharge(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/update-trip-charge`,
    payload
  );
}

// Update Status
updateTripChargeStatus(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/update-trip-charge-status`,
    payload
  );
}

getBookingTypes() { 
  return this.http.get(`${this.baseUrl}/master/data/triptypeactive`);
}


//////////////Consumer booking History//////////////
getPendingBookings(payload: any) {
  return this.http.post(`${this.baseUrl}/bookings/pending`,payload);
}

getConfirmedBookings(payload: any) {
  return this.http.post(`${this.baseUrl}/bookings/confirmed`,payload);
}


getAssignedBookings(payload: any) {
  return this.http.post(`${this.baseUrl}/bookings/assigned`,payload);
}

getCompletedBookings(payload: any) {
  return this.http.post(`${this.baseUrl}/bookings/completed`,payload);
}

getCancelledBookings(payload: any) {
  return this.http.post(`${this.baseUrl}/bookings/cancelled`,payload);
}

//////Grevience////////

getComplaintTypes() { 
  return this.http.get(`${this.baseUrl}/master/data/complaint-types`);
}

   getTankerStatus(): Observable<any> {
    return this.http
      .get<any>(`${this.baseUrl}/tanker/status/list`)  
  }
createCustomerComplaint(payload: any) { 
  return this.http.post(`${this.baseUrl}/customer/grievance/create`,payload);
}

updateCustomerGrevience(payload: any) { 
  return this.http.put(`${this.baseUrl}/customer/grievance/update`,payload);
}

getGrievenceList(payload: any) { 
  return this.http.post(`${this.baseUrl}/customer/admin/grievance/list`,payload);
}

getConsumerGrievancesListById(payload:any){
   return this.http.post(`${this.baseUrl}/customer/grievance/complaint-number/details`,payload);
}

getConsumerGrievancesList(payload:any){
   return this.http.post(`${this.baseUrl}/customer/consumer/grievance/list`,payload);
}


getApprovalTariff(payload: any) { 
  return this.http.post(`${this.baseUrl}/master/data/approval-tariff`,payload);
}


getTankerTypesList() { 
  return this.http.get(`${this.baseUrl}/master/data/tankertype`);
}

getAllTankerCapacityList() { 
  return this.http.get(`${this.baseUrl}/master/data/tankerCapacityactive`);
}

getProcessStatus() { 
  return this.http.get(`${this.baseUrl}/tanker/process-statuses/list`);
}

createUnsheduledTrips(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/unscheduled/create`,
    payload,
    { responseType: 'text' }
  );
}

initiateProcess(payload: any) {
  return this.http.post(
    `${this.baseUrl}/tanker/initiate-process`,
    payload,
    { responseType: 'text' }
  );
}


//////////////Tanker Owner Module///////////////

generateTankerOwnerOtp(payload: any) {
  return this.http.post(`${this.baseUrl}/owner/generate-otp`, payload, {
    responseType: 'text'
  });
}

reGenerateTankerOwnerOtp(payload: any) {
  return this.http.post(`${this.baseUrl}/auth/regenerate-otp`, payload, {
    responseType: 'text'
  });
}

validateTankerOwnerOtp(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/validate-otp`,payload,{ responseType: "text" });
}

tankerOwnerRegistration(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/register`,payload,{ responseType: "text" });
}

updateTankerOwner(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/update`,payload,{ responseType: "text" });
}

getTankerOwnerDetails() { 
  return this.http.get(`${this.baseUrl}/owner/details`);
}

loginTankerOwner(payload: any) { 
  return this.http.post(`${this.baseUrl}/staff/login`,payload);
}

verifyTankerOwner(payload: any) { 
  return this.http.post(`${this.baseUrl}/staff/verify`,payload);
}

getOwnerTankers(payload: any) { 
  return this.http.post(`${this.baseUrl}/tanker/my-tankers`,payload);
}

getOwnerTankerHistory(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/history`,payload);
}

getTankersLatLongs(payload: any) { 
  return this.http.post(`${this.baseUrl}/AVTS/tracking`,payload);
}

getAVTSFsSummary(){
  return this.http.get(`${this.baseUrl}/AVTS/fsSummary`); 
}

getReportedThrough() { 
  return this.http.get(`${this.baseUrl}/master/data/tanker-offence/reported-through`);
}

getOffenceType() { 
  return this.http.get(`${this.baseUrl}/master/data/tanker-offence/types`);
}

getActionTaken() { 
  return this.http.get(`${this.baseUrl}/master/data/tanker-offence/action-taken`);
}

getConsumerRefundedList(payload: any) { 
  return this.http.post(`${this.baseUrl}/bookings/refunded`,payload,{ responseType: "text" });
}

searchTankerVehicle(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/tanker/search`,payload);
}

createOffence(payload: any) { 
  return this.http.post(`${this.baseUrl}/tankeroffence/create`,payload,{ responseType: "text" });
}

editOffence(payload: any) { 
  return this.http.put(`${this.baseUrl}/tankeroffence/update`,payload,{ responseType: "text" });
}

tankerOffenceList(payload: any) { 
  return this.http.post(`${this.baseUrl}/tankeroffence/list`,payload);
}

getOffenceById(id: number) {
  return this.http.get(
    `${this.baseUrl}/tankeroffence/tankeroffence/${id}`,
  );
}

getTankerOwners(payload: any) { 
  return this.http.post(`${this.baseUrl}/owner/search`,payload);
}

createDesignation(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/designation/create`,
    payload,{ responseType: "text" }
  );
}

updateDesignation(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/designation/update`,
    payload,{ responseType: "text" }
  );
}

getAlldesignationList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/designation/list`,
    payload
  );
}


toggleDesignationStatus(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/designation/toggle-status`,
    payload,{ responseType: "text" }
  );
}

getUserdesignation() {
  return this.http.get(
    `${this.baseUrl}/master/data/designation/list`
  );
}

createFrequency(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/freeOrderPeriod/Create`,
    payload
  );
}

updateFrequency(id: number, payload: any) {
  return this.http.put(
    `${this.baseUrl}/master/data/freeOrderPeriod/update/${id}`,
    payload
  );
}


updateFrequencyStatus(id: number) {
  return this.http.patch(
    `${this.baseUrl}/master/data/freeOrderPeriod-status/${id}`,
    {},
    {
      responseType: 'text'
    }
  );
}

getFrequencyList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/freeOrderPeriod/list`,
    payload
  );
}



createRatioConfig(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/ratio-config/create`,
    payload
  );
}

getRatioConfigList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/ratio-config/list`,
    payload
  );
}

updateRatio(id:any,payload: any) {
  return this.http.put(
    `${this.baseUrl}/master/data/ratio-config/update/${id}`,
    payload
  );
}

updateRatioStatus(id: number) {
  return this.http.patch(
    `${this.baseUrl}/master/data/ratio-config/toggle-status/${id}`,
    {},
    {
      responseType: 'text'
    }
  );
}

createPriority(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/priority-config/create`,
    payload
  );
}

updatePriority(payload: any) {
  return this.http.put(
    `${this.baseUrl}/master/data/priority-config/update`,
    payload
  );
}

getPriorityDetails(id: number) {
  return this.http.get(
    `${this.baseUrl}/master/data/priority-config/${id}`
  );
}

getPriorityConfigList(payload: any) {
  return this.http.post(
    `${this.baseUrl}/master/data/priority-config/list`,
    payload
  );
}

updatePriorityStatus(id: number) {
  return this.http.patch(
    `${this.baseUrl}/master/data/priority-config/toggle-status/${id}`,
    {},
    {
      responseType: 'text'
    }
  );
}





revokeOrder(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/reopen`,
    payload,{ responseType: "text" }
  );
}

cancelCustomerBooking(payload: any) {
  return this.http.post(
    `${this.baseUrl}/bookings/cancel`,
    payload,{ responseType: "text" }
  );
}

 getConsumerDashboardDetails() {
    return this.http
      .get(`${this.baseUrl}/bookings/customer/dashboard/counts`)
 
  }

   getOwnerDashboardDetails() {
    return this.http
      .get(`${this.baseUrl}/owner/dashboard/count`)
 
  }


  editConsumer(payload: any) {
  return this.http.post(
    `${this.baseUrl}/customers/details/update`,
    payload,{ responseType: "text" }
  );
}

  getTripCharge(payload) {
    return this.http
      .post(`${this.baseUrl}/bookings/trip-charge`, payload)

  }

  createUnscheduled(payload: any) {
    return this.http.post(
      `${this.baseUrl}/bookings/manager/unscheduled/create`,
      payload, { responseType: "text" }
    );
  }

  createUnscheduledByManager(payload: any) {
    return this.http.post(
      `${this.baseUrl}/bookings/manager/unscheduled/generate-bookings`,
      payload
    );
  }

   usageHistory(payload: any) {
    return this.http.post(
      `${this.baseUrl}/tokens/manager/fs/summary`,
      payload
    );
  }

   tankerAuditHistory(payload: any) {
    return this.http.post(
      `${this.baseUrl}/tanker/master/audit/logs`,
      payload
    );
  }

  managerFsToken(payload: any) {
    return this.http.post(
      `${this.baseUrl}/tokens/monthly/manager/summary/station`,
      payload
    );
  }

  getTankerCapacity(payload: any) {
    return this.http.post(`${this.baseUrl}/consumer/capacities`, payload);
  }

  // verfiyBooking(payload: any) {
  //   return this.http.post(`${this.baseUrl}/customers/hmwssb/verifyCanForTankerBooking`, payload);
  // }

    verfiyBooking(payload: any) {
    return this.http.post(`${this.baseUrl}/consumer/bookingStatus`, payload);
  }

  //17.09.2026

  getFeedbackList(payload:any){
    return this.http.post(`${this.baseUrl}/consumer/feedBack/list`, payload)
  }

    submitFeedback(payload: any) {
    return this.http.post(`${this.baseUrl}/consumer/submitFeedback`, payload);

  }

   getFeedbackReasons(payload:any) {
    return this.http
      .post(`${this.baseUrl}/consumer/reasons`,payload)
 
  }


}












